@let sessionState = authService.sessionCheckState$ | async;
<div kendoTooltip geneaRouteData [attr.inert]="sessionState !== 'idle' ? '' : null"
     [attr.aria-busy]="sessionState === 'checking'">
  <router-outlet></router-outlet>
  <navigation-indicator></navigation-indicator>
  <app-toastr></app-toastr>
</div>
@if (sessionState === 'checking') {
  <!-- The same spinner the login page shows while signing in. -->
  <div class="session-check-overlay session-check-spinner" role="status" aria-live="polite" aria-label="Loading">
    <app-loading-indicator [loading]="true"></app-loading-indicator>
  </div>
} @else if (sessionState === 'unavailable') {
  <div class="session-check-overlay">
    <section class="session-check-panel" role="status" aria-live="polite">
      <p>We couldn't confirm you're signed in. Please try again in a moment.</p>
      <button type="button" class="btn btn-primary" (click)="authService.retrySessionCheck()">Try again</button>
    </section>
  </div>
}
